<script lang="ts" setup>
import { ContentIcon } from '@metapic-apps/shared'

import CalendarIcon from '@/assets/icons/calendar.svg?component'
import InfoIcon from '@/assets/icons/info.svg?component'
import PaymentIcon from '@/assets/icons/payment.svg?component'
import PriorityIcon from '@/assets/icons/priority.svg?component'
import TargetIcon from '@/assets/icons/target.svg?component'
import { useBlocksNavigation } from '@/lib/hooks/blocks-navigation.hook'
import FlexComponent from '@/ui-library/atoms/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent.vue'

const sections = [
  'campaign-form-block-target',
  'campaign-form-block-campaign',
  'campaign-form-block-content',
  'campaign-form-block-payment',
  'campaign-form-block-calendar',
  'campaign-form-block-priority',
]
const { activeSection, scrollToBlock } = useBlocksNavigation(sections, 73)
</script>
<template>
  <FlexComponent direction="column" :gap="24" class="campaign-form__navigation">
    <FlexComponent
      :gap="16"
      align="center"
      :class="['campaign-form__navigation-item', { active: activeSection === 'campaign-form-block-target' }]"
      @click="scrollToBlock('campaign-form-block-target')"
    >
      <el-icon :size="24">
        <TargetIcon />
      </el-icon>
      <TypographyComponent variant="title-large">Target</TypographyComponent>
    </FlexComponent>
    <FlexComponent
      :gap="16"
      align="center"
      :class="['campaign-form__navigation-item', { active: activeSection === 'campaign-form-block-campaign' }]"
      @click="scrollToBlock('campaign-form-block-campaign')"
    >
      <el-icon :size="24">
        <InfoIcon />
      </el-icon>
      <TypographyComponent variant="title-large">Campaign</TypographyComponent>
    </FlexComponent>
    <FlexComponent
      :gap="16"
      align="center"
      :class="['campaign-form__navigation-item', { active: activeSection === 'campaign-form-block-content' }]"
      @click="scrollToBlock('campaign-form-block-content')"
    >
      <el-icon :size="24">
        <ContentIcon />
      </el-icon>
      <TypographyComponent variant="title-large">Content</TypographyComponent>
    </FlexComponent>
    <FlexComponent
      :gap="16"
      align="center"
      :class="['campaign-form__navigation-item', { active: activeSection === 'campaign-form-block-payment' }]"
      @click="scrollToBlock('campaign-form-block-payment')"
    >
      <el-icon :size="24">
        <PaymentIcon />
      </el-icon>
      <TypographyComponent variant="title-large">Payment</TypographyComponent>
    </FlexComponent>
    <FlexComponent
      :gap="16"
      align="center"
      :class="['campaign-form__navigation-item', { active: activeSection === 'campaign-form-block-calendar' }]"
      @click="scrollToBlock('campaign-form-block-calendar')"
    >
      <el-icon :size="24">
        <CalendarIcon />
      </el-icon>
      <TypographyComponent variant="title-large">Start/End</TypographyComponent>
    </FlexComponent>
    <FlexComponent
      :gap="16"
      align="center"
      :class="['campaign-form__navigation-item', { active: activeSection === 'campaign-form-block-priority' }]"
      @click="scrollToBlock('campaign-form-block-priority')"
    >
      <el-icon :size="24">
        <PriorityIcon />
      </el-icon>
      <TypographyComponent variant="title-large">Priority</TypographyComponent>
    </FlexComponent>
  </FlexComponent>
</template>
<style lang="scss" scoped>
$breakpoint-lg: 992px;

h4 {
  margin-bottom: 0;
}

.campaign-form__navigation {
  position: sticky;
  width: 200px;
  height: 100%;
  display: none;

  @media (min-width: $breakpoint-lg) {
    display: flex;
    top: 94px;
  }
}

.campaign-form__navigation-item {
  opacity: 0.4;
  cursor: pointer;

  :deep(.el-icon) {
    & path {
      fill: var(--primary);
    }
  }

  h4 {
    color: var(--primary);
  }

  &.active {
    opacity: 1;
  }
}
</style>
